// Nuxt only finds middleware if they're in the directory `middleware`.
// Read more: https://fr.nuxtjs.org/guide/routing#middleware
import staffOrCareBpo from '@auth-oauth2/middleware/staffOrCareBpo'

export default staffOrCareBpo
